export default (state: any, action: any) => ({
  ...state,
  leadsPool: {
    ...state.leadsPool,
    data: action.leadsPool,
  },
});
